module.exports = __webpack_public_path__ + "static/appero-export-min-db45da4b5f764f0ebeb59b126a2dfbdd.mp4";